// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__bJRbL","detail":"Detail_detail__tY+ao","title":"Detail_title__1z7kl","list":"Detail_list__nzqDs"};